module.exports = __webpack_public_path__ + "static/media/clinics.07792e9d.png";